(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.recommendationsLoaded = false;
    }

    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.closeButtons = this.querySelectorAll('[data-close]');
      this.quantityButtons = this.querySelectorAll('[data-action]');
      this.recommendationsContainer = this.querySelector('[data-cart-recommendations]');

      this.bindEvents();
    }

    bindEvents() {
      // Close buttons
      this.closeButtons.forEach((btn) => {
        btn.addEventListener('click', () => this.close());
      });

      // Backdrop click
      this.dialog?.addEventListener('click', (e) => {
        if (e.target === this.dialog) this.close();
      });

      // Escape key — close Complete the Look first, then the drawer
      this.dialog?.addEventListener('cancel', (e) => {
        e.preventDefault();
        const ctlPanel = this.querySelector('[data-complete-the-look-panel]');
        if (ctlPanel?.classList.contains('is-open')) {
          this.closeCompleteTheLookPanel();
          return;
        }
        this.close();
      });

      // Quantity & Remove buttons
      this.quantityButtons.forEach((btn) => {
        btn.addEventListener('click', (e) => this.handleQuantityChange(e));
      });

      // Add to cart from recommendations & Complete the Look panel
      this.delegate(this, 'click', '[data-add-to-cart]', this.handleRecommendationAdd.bind(this));

      // Complete the Look side panel
      this.delegate(this, 'click', '[data-open-complete-the-look]', (e, btn) => {
        e.preventDefault();
        const key = btn.dataset.lineKey;
        if (key) this.openCompleteTheLookPanel(key);
      });
      this.delegate(this, 'click', '[data-ctl-close]', () => this.closeCompleteTheLookPanel());
      this.delegate(this, 'change', '[data-variant-select]', (e, select) => {
        const wrap = select.closest('.cart-drawer__ctl-product');
        const addBtn = wrap?.querySelector('[data-add-to-cart]');
        if (!addBtn) return;
        const opt = select.options[select.selectedIndex];
        addBtn.dataset.variantId = select.value;
        if (opt?.disabled) {
          addBtn.disabled = true;
        } else {
          addBtn.disabled = false;
        }
      });

      // Listen for cart:open event
      document.addEventListener('cart:open', () => this.open());

      // Listen for cart:add event to refresh drawer content
      document.addEventListener('cart:add', () => this.refreshDrawer());

      // Also expose globally for direct access
      window.cartDrawer = this;
    }

    // Event delegation helper
    delegate(element, event, selector, handler) {
      element.addEventListener(event, (e) => {
        const target = e.target.closest(selector);
        if (target && element.contains(target)) {
          handler(e, target);
        }
      });
    }

    open() {
      if (!this.dialog) return;
      this.dialog.classList.remove('is-closing');
      this.dialog.showModal();
      document.body.classList.add('scroll-lock');

      // Load recommendations when drawer opens
      this.loadRecommendations();
      // Load empty state products when drawer is empty
      this.loadEmptyStateProducts();
    }

    close() {
      if (!this.dialog || !this.dialog.open) return;

      this.closeCompleteTheLookPanel();

      // Add closing class for animation
      this.dialog.classList.add('is-closing');

      // Wait for animation to complete, then close
      const handleAnimationEnd = () => {
        this.dialog.classList.remove('is-closing');
        this.dialog.close();
        document.body.classList.remove('scroll-lock');
        this.dialog.removeEventListener('animationend', handleAnimationEnd);
      };

      this.dialog.addEventListener('animationend', handleAnimationEnd, { once: true });

      // Fallback in case animation doesn't fire
      setTimeout(() => {
        if (this.dialog.open) {
          this.dialog.classList.remove('is-closing');
          this.dialog.close();
          document.body.classList.remove('scroll-lock');
        }
      }, 350);
    }

    async handleQuantityChange(e) {
      const action = e.target.dataset.action;
      const key = e.target.dataset.key;

      if (!key) return;

      const item = this.querySelector(`[data-key="${key}"]`);
      const input = item?.querySelector('[data-quantity-input]');

      if (!input) return;

      let quantity = parseInt(input.value);

      if (action === 'increase') {
        quantity++;
      } else if (action === 'decrease') {
        quantity = Math.max(0, quantity - 1);
      } else if (action === 'remove') {
        quantity = 0;
      }

      await this.updateCart(key, quantity);
    }

    openCompleteTheLookPanel(lineKey) {
      const panel = this.querySelector('[data-complete-the-look-panel]');
      if (!panel) return;
      const tpl = Array.from(this.querySelectorAll('template[data-ctl-template]')).find(
        (t) => t.dataset.ctlTemplate === lineKey
      );
      if (!tpl) return;
      const body = this.querySelector('[data-ctl-body]');
      if (!body) return;
      body.innerHTML = '';
      body.appendChild(tpl.content.cloneNode(true));
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
    }

    closeCompleteTheLookPanel() {
      const panel = this.querySelector('[data-complete-the-look-panel]');
      if (!panel) return;
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      const body = this.querySelector('[data-ctl-body]');
      if (body) body.innerHTML = '';
    }

    async handleRecommendationAdd(e, button) {
      e.preventDefault();

      const variantId = button.dataset.variantId;
      if (!variantId || button.disabled || button.classList.contains('is-loading')) return;

      button.classList.add('is-loading');

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: parseInt(variantId),
            quantity: 1,
          }),
        });

        if (response.ok) {
          button.classList.remove('is-loading');
          button.classList.add('is-added');
          button.querySelector('span').textContent = 'Added';

          // Get updated cart
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();

          // Refresh drawer content and update count
          this.refreshDrawer();
          this.updateCartCount(cart.item_count);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));

          // Reset button after delay
          setTimeout(() => {
            button.classList.remove('is-added');
            button.querySelector('span').textContent = 'Add';
          }, 2000);
        } else {
          button.classList.remove('is-loading');
          console.error('Failed to add item');
        }
      } catch (error) {
        button.classList.remove('is-loading');
        console.error('Error adding to cart:', error);
      }
    }

    isRecommendationInStock(product) {
      const variants = product.variants;
      if (Array.isArray(variants) && variants.length > 0) {
        const known = variants.filter((v) => typeof v.available === 'boolean');
        if (known.length > 0) {
          return known.some((v) => v.available);
        }
      }
      return product.available === true;
    }

    async loadRecommendations() {
      if (!this.recommendationsContainer) return;

      const productId = this.recommendationsContainer.dataset.productId;
      const limit = parseInt(this.recommendationsContainer.dataset.limit) || 4;
      const intent = this.recommendationsContainer.dataset.intent || 'related';
      const moneyFormat = this.recommendationsContainer.dataset.moneyFormat || '{' + '{amount}' + '}';
      const fallbackUrl = this.recommendationsContainer.dataset.fallbackUrl;

      // Show container with skeletons
      this.recommendationsContainer.style.display = '';

      try {
        let products = [];

        // Recommendations API max limit is 10 — request full page so filtering OOS still fills the carousel
        const recApiLimit = 10;

        if (productId) {
          products = await this.fetchRecommendations(productId, recApiLimit, intent);

          if (products.length === 0 && intent === 'related') {
            products = await this.fetchRecommendations(productId, recApiLimit, 'complementary');
          }
        }

        if (products.length === 0 && fallbackUrl) {
          products = await this.fetchCollectionProducts(fallbackUrl);
        }

        products = products.filter((p) => this.isRecommendationInStock(p)).slice(0, limit);

        if (products.length === 0) {
          this.recommendationsContainer.style.display = 'none';
          return;
        }

        // Render product cards
        const carousel = this.querySelector('[data-recommendations-carousel]');
        if (!carousel) return;

        carousel.innerHTML = products.map((product) => this.renderRecommendationCard(product, moneyFormat)).join('');
        this.recommendationsLoaded = true;
      } catch (error) {
        console.error('Error loading recommendations:', error);
        this.recommendationsContainer.style.display = 'none';
      }
    }

    async fetchRecommendations(productId, limit, intent) {
      const url = `/recommendations/products.json?product_id=${productId}&limit=${limit}&intent=${intent}`;
      const response = await fetch(url);

      if (!response.ok) return [];

      const data = await response.json();
      return data.products || [];
    }

    async fetchCollectionProducts(url) {
      try {
        const response = await fetch(url);
        if (!response.ok) return [];

        const data = await response.json();
        return data.products || [];
      } catch {
        return [];
      }
    }

    async loadEmptyStateProducts() {
      const container = this.querySelector('[data-empty-state-products]');
      if (!container) return;

      const url = container.dataset.collectionUrl;
      const limit = parseInt(container.dataset.limit) || 4;
      const moneyFormat = container.dataset.moneyFormat || '{' + '{amount}' + '}';
      if (!url) return;

      const carousel = container.querySelector('[data-empty-state-carousel]');
      if (!carousel) return;

      try {
        const products = await this.fetchCollectionProducts(url);
        const available = products.filter((p) => this.isRecommendationInStock(p)).slice(0, limit);
        if (available.length === 0) {
          container.style.display = 'none';
          return;
        }
        carousel.innerHTML = available
          .map((p) => this.renderRecommendationCard(p, moneyFormat, { priceInDollars: true }))
          .join('');
      } catch (error) {
        console.error('Error loading empty state products:', error);
        container.style.display = 'none';
      }
    }

    renderRecommendationCard(product, moneyFormat, options = {}) {
      // Collection products.json may omit url; build from handle if needed
      const productUrl = product.url || (product.handle ? `/products/${product.handle}` : '#');

      const variants = product.variants;
      const variantForOffer =
        Array.isArray(variants) && variants.length > 0
          ? variants.find((v) => v.available === true) ?? variants[0]
          : null;

      // Normalize price: collection products.json may have price only on variants; collection API returns dollars, recommendations API returns cents
      let priceRaw = Number(
        product.price ?? variantForOffer?.price ?? product.variants?.[0]?.price ?? 0
      );
      let compareRaw = Number(
        product.compare_at_price ??
          variantForOffer?.compare_at_price ??
          product.variants?.[0]?.compare_at_price ??
          0
      );
      if (options.priceInDollars) {
        priceRaw = Math.round(priceRaw * 100);
        compareRaw = Math.round(compareRaw * 100);
      }
      const priceCents = priceRaw;
      const compareCents = compareRaw;

      const formatMoney = (cents) => {
        if (typeof window.themeFormatMoney === 'function') {
          return window.themeFormatMoney(cents);
        }
        const num = Number(cents);
        if (Number.isNaN(num) || num < 0) return '0.00';
        const amount = (num / 100).toFixed(2);
        const amountKey = '{' + '{amount}' + '}';
        const noDecimalsKey = '{' + '{amount_no_decimals}' + '}';
        return String(moneyFormat || amount)
          .replace(amountKey, amount)
          .replace(noDecimalsKey, Math.round(num / 100));
      };

      // Handle both string URLs and image objects from different API responses
      let imageUrl = product.featured_image;
      if (!imageUrl && product.images?.[0]) {
        imageUrl = typeof product.images[0] === 'string' ? product.images[0] : product.images[0].src;
      }
      const imageHtml = imageUrl
        ? `<img src="${imageUrl.replace(/\.([^.]+)$/, '_300x400.$1')}" alt="${product.title}" loading="lazy">`
        : `<div class="placeholder-svg"></div>`;

      const onSale = compareCents > 0 && compareCents > priceCents;
      const priceHtml = onSale
        ? `<span class="cart-drawer__rec-price-sale">${formatMoney(priceCents)}</span>
           <s class="cart-drawer__rec-price-compare">${formatMoney(compareCents)}</s>`
        : `<span>${formatMoney(priceCents)}</span>`;

      const hasVariants = product.variants?.length > 1;
      const purchasable = this.isRecommendationInStock(product);

      let actionHtml;
      if (!purchasable) {
        actionHtml = `<span class="cart-drawer__rec-sold-out">Sold Out</span>`;
      } else if (hasVariants) {
        actionHtml = `
          <a href="${productUrl}" class="cart-drawer__rec-add">
            <span>Select</span>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
              <path d="M4.5 2L8.5 6L4.5 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </a>`;
      } else {
        actionHtml = `
          <button type="button" class="cart-drawer__rec-add" data-add-to-cart data-variant-id="${variantForOffer?.id}">
            <span>Add</span>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
              <path d="M6 1v10M1 6h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </button>`;
      }

      return `
        <div class="cart-drawer__rec-card">
          <a href="${productUrl}" class="cart-drawer__rec-image">
            ${imageHtml}
          </a>
          <div class="cart-drawer__rec-info">
            <h4 class="cart-drawer__rec-title">
              <a href="${productUrl}">${product.title}</a>
            </h4>
            <div class="cart-drawer__rec-price">
              ${priceHtml}
            </div>
            ${actionHtml}
          </div>
        </div>`;
    }

    async updateCart(key, quantity) {
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ id: key, quantity }),
        });

        if (response.ok) {
          const cart = await response.json();
          this.refreshDrawer();
          this.updateCartCount(cart.item_count);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        }
      } catch (error) {
        console.error('Error updating cart:', error);
      }
    }

    async refreshDrawer() {
      try {
        const response = await fetch('/?section_id=cart-drawer');
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newContent = doc.querySelector('[data-cart-content]');
        const newFooter = doc.querySelector('.cart-drawer__footer');
        const newCount = doc.querySelector('[data-cart-count]');
        const newShippingBar = doc.querySelector('.cart-drawer__shipping-bar');
        const newRecommendations = doc.querySelector('[data-cart-recommendations]');

        if (newContent) {
          this.querySelector('[data-cart-content]').innerHTML = newContent.innerHTML;
        }
        if (newFooter) {
          const currentFooter = this.querySelector('.cart-drawer__footer');
          if (currentFooter) {
            currentFooter.replaceWith(newFooter);
          } else {
            const content = this.querySelector('[data-cart-content]');
            if (content) content.after(newFooter);
          }
        }
        if (newCount) {
          this.querySelector('[data-cart-count]').textContent = newCount.textContent;
        }
        if (newShippingBar) {
          const currentBar = this.querySelector('.cart-drawer__shipping-bar');
          if (currentBar) {
            currentBar.replaceWith(newShippingBar);
          }
        }

        // Update recommendations container reference and reload if product changed
        this.recommendationsContainer = this.querySelector('[data-cart-recommendations]');
        if (this.recommendationsContainer) {
          this.recommendationsLoaded = false;
          this.loadRecommendations();
        }

        // Rebind events
        this.quantityButtons = this.querySelectorAll('[data-action]');
        this.quantityButtons.forEach((btn) => {
          btn.addEventListener('click', (e) => this.handleQuantityChange(e));
        });
      } catch (error) {
        console.error('Error refreshing cart drawer:', error);
      }
    }

    updateCartCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = count;
      });
    }
  }

  customElements.define('cart-drawer', CartDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /**
   * Sticky Header Component
   * Adds scroll detection for sticky header styling
   * Accounts for announcement bar height when present
   */
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.baseScrollThreshold = 10;
      this.hysteresisBuffer = 15;
      this.ticking = false;
      this.announcementBar = null;
      this.lastScrollY = 0;
      this.scrollUpDelta = 0;
      this.revealThreshold = 30;
      this.isScrolled = false;
    }

    connectedCallback() {
      this.stickyMode = this.dataset.stickyMode || 'none';
      this.handleScroll = this.handleScroll.bind(this);
      this.onScroll = this.onScroll.bind(this);

      this.announcementBar = document.querySelector('.announcement-bar-section .announcement-bar');
      this.calculateThreshold();
      this.lastScrollY = window.scrollY;

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', () => this.calculateThreshold(), { passive: true });
      this.handleScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    calculateThreshold() {
      if (this.announcementBar) {
        this.scrollThreshold = this.announcementBar.offsetHeight;
      } else {
        this.scrollThreshold = this.baseScrollThreshold;
      }
    }

    onScroll() {
      if (!this.ticking) {
        requestAnimationFrame(() => {
          this.handleScroll();
          this.ticking = false;
        });
        this.ticking = true;
      }
    }

    handleScroll() {
      const currentScrollY = window.scrollY;
      const scrolled = this.isScrolled
        ? currentScrollY > Math.max(0, this.scrollThreshold - this.hysteresisBuffer)
        : currentScrollY > this.scrollThreshold;

      if (scrolled !== this.isScrolled) {
        this.isScrolled = scrolled;
        this.classList.toggle('is-scrolled', scrolled);
      }

      if (this.stickyMode === 'on-scroll-up') {
        const delta = currentScrollY - this.lastScrollY;

        if (delta < 0) {
          this.scrollUpDelta += Math.abs(delta);
        } else {
          this.scrollUpDelta = 0;
        }

        if (!scrolled || currentScrollY <= 0) {
          this.classList.remove('header--revealed');
        } else if (this.scrollUpDelta > this.revealThreshold) {
          this.classList.add('header--revealed');
        } else if (delta > 0) {
          this.classList.remove('header--revealed');
        }
      }

      this.lastScrollY = currentScrollY;
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /**
   * Mega Menu Component
   * Handles hover intent, keyboard navigation, and accessibility
   */
  class MegaMenu extends HTMLElement {
    constructor() {
      super();
      this.trigger = this.querySelector('.mega-menu__trigger');
      this.panel = this.querySelector('.mega-menu__panel');
      this.isOpen = false;
      this.hoverTimeout = null;
      this.closeTimeout = null;
      this.hoverDelay = 150; // Delay before opening (prevents accidental triggers)
      this.closeDelay = 300; // Delay before closing (allows moving to panel)
    }

    connectedCallback() {
      if (!this.trigger || !this.panel) return;

      // Mouse events with hover intent
      this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));

      // Click support for touch devices
      this.trigger.addEventListener('click', this.onTriggerClick.bind(this));

      // Keyboard navigation
      this.trigger.addEventListener('keydown', this.onTriggerKeydown.bind(this));
      this.panel.addEventListener('keydown', this.onPanelKeydown.bind(this));

      // Close when clicking outside
      document.addEventListener('click', this.onDocumentClick.bind(this));

      // Close on escape
      document.addEventListener('keydown', this.onDocumentKeydown.bind(this));

      // Close other mega menus when this one opens
      this.addEventListener('megamenu:open', () => {
        document.querySelectorAll('mega-menu').forEach((menu) => {
          if (menu !== this && menu.isOpen) {
            menu.close();
          }
        });
      });
    }

    disconnectedCallback() {
      clearTimeout(this.hoverTimeout);
      clearTimeout(this.closeTimeout);
    }

    onMouseEnter() {
      clearTimeout(this.closeTimeout);
      this.hoverTimeout = setTimeout(() => {
        this.open();
      }, this.hoverDelay);
    }

    onMouseLeave() {
      clearTimeout(this.hoverTimeout);
      this.closeTimeout = setTimeout(() => {
        this.close();
      }, this.closeDelay);
    }

    onTriggerClick(e) {
      e.preventDefault();
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }

    onTriggerKeydown(e) {
      switch (e.key) {
        case 'Enter':
        case ' ':
          e.preventDefault();
          if (this.isOpen) {
            this.close();
          } else {
            this.open();
            // Focus first link in panel
            const firstLink = this.panel.querySelector('a, button');
            if (firstLink) firstLink.focus();
          }
          break;
        case 'ArrowDown':
          e.preventDefault();
          this.open();
          const firstLink = this.panel.querySelector('a, button');
          if (firstLink) firstLink.focus();
          break;
        case 'Escape':
          if (this.isOpen) {
            e.preventDefault();
            this.close();
            this.trigger.focus();
          }
          break;
      }
    }

    onPanelKeydown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        this.close();
        this.trigger.focus();
        return;
      }

      // Arrow key navigation within panel
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        const focusableElements = [...this.panel.querySelectorAll('a, button')];
        const currentIndex = focusableElements.indexOf(document.activeElement);

        if (currentIndex === -1) return;

        e.preventDefault();
        let nextIndex;

        if (e.key === 'ArrowDown') {
          nextIndex = currentIndex + 1;
          if (nextIndex >= focusableElements.length) nextIndex = 0;
        } else {
          nextIndex = currentIndex - 1;
          if (nextIndex < 0) nextIndex = focusableElements.length - 1;
        }

        focusableElements[nextIndex].focus();
      }
    }

    onDocumentClick(e) {
      if (this.isOpen && !this.contains(e.target)) {
        this.close();
      }
    }

    onDocumentKeydown(e) {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
        this.trigger.focus();
      }
    }

    open() {
      if (this.isOpen) return;

      this.isOpen = true;
      this.setAttribute('open', '');
      this.trigger.setAttribute('aria-expanded', 'true');

      this.dispatchEvent(new CustomEvent('megamenu:open', { bubbles: true }));
    }

    close() {
      if (!this.isOpen) return;

      this.isOpen = false;
      this.removeAttribute('open');
      this.trigger.setAttribute('aria-expanded', 'false');

      this.dispatchEvent(new CustomEvent('megamenu:close', { bubbles: true }));
    }
  }

  customElements.define('mega-menu', MegaMenu);

  /**
   * Localization Selector Component
   * Handles dropdown toggle and form submissions for country/language selection
   */
  class LocalizationSelector extends HTMLElement {
    constructor() {
      super();
      this.trigger = this.querySelector('.header__localization-trigger');
      this.dropdown = this.querySelector('.header__localization-dropdown');
      this.selects = this.querySelectorAll('select');
      this.isOpen = false;
    }

    connectedCallback() {
      if (!this.trigger || !this.dropdown) return;

      // Toggle dropdown
      this.trigger.addEventListener('click', this.onTriggerClick.bind(this));

      // Close when clicking outside
      document.addEventListener('click', this.onDocumentClick.bind(this));

      // Close on escape
      document.addEventListener('keydown', this.onDocumentKeydown.bind(this));

      // Handle select changes
      this.selects.forEach((select) => {
        select.addEventListener('change', this.onSelectChange.bind(this));
      });
    }

    onTriggerClick(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }

    onDocumentClick(e) {
      if (this.isOpen && !this.contains(e.target)) {
        this.close();
      }
    }

    onDocumentKeydown(e) {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
        this.trigger.focus();
      }
    }

    onSelectChange(e) {
      const form = e.target.closest('form');
      if (form) {
        form.submit();
      }
    }

    open() {
      if (this.isOpen) return;
      this.isOpen = true;
      this.setAttribute('open', '');
      this.trigger.setAttribute('aria-expanded', 'true');
    }

    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.removeAttribute('open');
      this.trigger.setAttribute('aria-expanded', 'false');
    }
  }

  customElements.define('localization-selector', LocalizationSelector);

  /**
   * Mobile Localization Form Handler
   * Auto-submits localization forms on select change
   */
  (function () {
    const mobileSelects = document.querySelectorAll('.mobile-menu__localization-select');

    mobileSelects.forEach((select) => {
      select.addEventListener('change', function () {
        const form = this.closest('form');
        if (form) {
          form.submit();
        }
      });
    });
  })();

  /**
   * Mobile menu positioning and focus
   * Syncs drawer/backdrop top offset to the actual header bottom edge.
   * Only focuses search when opened via the search icon (not the hamburger).
   */
  (function () {
    const mobileMenu = document.getElementById('mobile-menu');
    const header = document.querySelector('sticky-header');
    const dialog = mobileMenu?.querySelector('.mobile-menu__dialog');
    const mobileSearchInput = document.getElementById('mobile-search-input');

    if (!mobileMenu || !header) return;

    document.querySelectorAll('[aria-controls="mobile-menu"]').forEach((trigger) => {
      trigger.addEventListener(
        'pointerdown',
        () => {
          mobileMenu.dataset.openTrigger = trigger.classList.contains('header__search-mobile')
            ? 'search'
            : 'menu';
        },
        { passive: true }
      );
    });

    function updateMobileMenuPosition() {
      if (!mobileMenu.hasAttribute('open')) return;
      const top = Math.round(header.getBoundingClientRect().bottom);
      mobileMenu.style.setProperty('--mobile-menu-top', `${top}px`);
    }

    function clearMobileMenuPosition() {
      mobileMenu.style.removeProperty('--mobile-menu-top');
    }

    function manageMobileMenuFocus() {
      requestAnimationFrame(() => {
        if (mobileMenu.dataset.openTrigger === 'search') {
          mobileSearchInput?.focus({ preventScroll: true });
        } else {
          mobileSearchInput?.blur();
          dialog?.focus({ preventScroll: true });
        }
      });
    }

    mobileMenu.addEventListener('drawer:open', () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          updateMobileMenuPosition();
          manageMobileMenuFocus();
        });
      });
    });

    mobileMenu.addEventListener('drawer:close', () => {
      mobileSearchInput?.blur();
      clearMobileMenuPosition();
    });
    window.addEventListener('resize', updateMobileMenuPosition, { passive: true });
  })();

  /**
   * Mobile Menu Transparent Header Handler
   * Removes transparent header effect when mobile menu is open
   */
  (function () {
    const mobileMenu = document.getElementById('mobile-menu');
    const header = document.querySelector('sticky-header');

    if (!mobileMenu || !header) return;

    const isTransparentEnabled = header.classList.contains('header--transparent');

    if (!isTransparentEnabled) return;

    mobileMenu.addEventListener('drawer:open', () => {
      header.classList.remove('header--transparent');
      header.classList.add('header--transparent-disabled');
    });

    mobileMenu.addEventListener('drawer:close', () => {
      // Only restore if we disabled it and scroll position is at top
      if (header.classList.contains('header--transparent-disabled')) {
        // Only restore transparent if not scrolled
        if (window.scrollY <= 10) {
          // Add transparent class first, then remove disabled to prevent size jump
          header.classList.add('header--transparent');
          header.classList.remove('header--transparent-disabled');
        } else {
          // Scrolled - just remove disabled class
          header.classList.remove('header--transparent-disabled');
        }
      }
    });
  })();

  /**
   * Mega Menu Transparent Header Handler
   * Removes transparent header effect when any mega menu is open
   */
  (function () {
    const header = document.querySelector('sticky-header');

    if (!header) return;

    const isTransparentEnabled = header.classList.contains('header--transparent');

    if (!isTransparentEnabled) return;

    // Track how many mega menus are currently open
    let openMegaMenuCount = 0;

    document.addEventListener('megamenu:open', () => {
      openMegaMenuCount++;
      if (openMegaMenuCount === 1) {
        // First mega menu opened - only disable transparency if header is currently transparent
        if (header.classList.contains('header--transparent') && !header.classList.contains('is-scrolled')) {
          header.classList.remove('header--transparent');
          header.classList.add('header--transparent-disabled');
        }
      }
    });

    document.addEventListener('megamenu:close', () => {
      openMegaMenuCount = Math.max(0, openMegaMenuCount - 1);
      if (openMegaMenuCount === 0) {
        // All mega menus closed - restore transparency if at top
        if (header.classList.contains('header--transparent-disabled')) {
          // Only restore transparent if not scrolled
          if (window.scrollY <= 10) {
            // Add transparent class first, then remove disabled to prevent size jump
            header.classList.add('header--transparent');
            header.classList.remove('header--transparent-disabled');
          } else {
            // Scrolled - just remove disabled class
            header.classList.remove('header--transparent-disabled');
          }
        }
      }
    });
  })();

  /**
   * Search drawer: predictive search (options + top results) while typing
   */
  (function () {
    const searchDrawer = document.getElementById('search-drawer');
    const searchInput = document.getElementById('search-input');
    const resultsRegion = document.getElementById('search-drawer-results');

    if (!searchDrawer || !searchInput || !resultsRegion) return;

    const stateIdle = resultsRegion.querySelector('[data-search-state="idle"]');
    const stateLoading = resultsRegion.querySelector('[data-search-state="loading"]');
    const stateResults = resultsRegion.querySelector('[data-search-state="results"]');
    const stateEmpty = resultsRegion.querySelector('[data-search-state="empty"]');
    const optionsContainer = resultsRegion.querySelector('[data-search-options]');
    const productsContainer = resultsRegion.querySelector('[data-search-products]');

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const suggestUrl = root.replace(/\/$/, '') + '/search/suggest.json';
    const minChars = 2;
    const debounceMs = 260;
    let debounceTimer = null;
    let abortController = null;

    function setState(state) {
      [stateIdle, stateLoading, stateResults, stateEmpty].forEach((el) => {
        if (el) el.hidden = true;
      });
      if (state === 'idle' && stateIdle) stateIdle.hidden = false;
      if (state === 'loading' && stateLoading) stateLoading.hidden = false;
      if (state === 'results' && stateResults) stateResults.hidden = false;
      if (state === 'empty' && stateEmpty) stateEmpty.hidden = false;
    }

    function escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    function renderOptions(queries) {
      if (!optionsContainer) return;
      const wrap = optionsContainer.closest('.search-drawer__options-wrap');
      if (!queries || queries.length === 0) {
        optionsContainer.innerHTML = '';
        if (wrap) wrap.style.display = 'none';
        return;
      }
      if (wrap) wrap.style.display = 'block';
      optionsContainer.innerHTML = queries
        .slice(0, 5)
        .map(
          (q) =>
            `<a href="${escapeHtml(q.url)}" class="search-drawer__option">${q.styled_text || escapeHtml(q.text)}</a>`
        )
        .join('');
    }

    function renderProducts(products) {
      if (!productsContainer) return;
      const wrap = productsContainer.closest('.search-drawer__products-wrap');
      if (!products || products.length === 0) {
        productsContainer.innerHTML = '';
        if (wrap) wrap.style.display = 'none';
        return;
      }
      if (wrap) wrap.style.display = 'block';
      const formatMoney = (value) => {
        if (typeof window.themeFormatMoney === 'function') {
          return window.themeFormatMoney(value);
        }
        if (typeof window.Shopify !== 'undefined' && window.Shopify.formatMoney) {
          return window.Shopify.formatMoney(value);
        }
        const num = parseFloat(value);
        if (Number.isInteger(num) && num >= 100) return (num / 100).toFixed(2);
        return num.toFixed(2);
      };
      productsContainer.innerHTML = products
        .slice(0, 6)
        .map((p) => {
          const img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image || '';
          const price = p.price != null ? formatMoney(p.price) : '';
          const comparePrice =
            p.compare_at_price_min && p.compare_at_price_min > 0 ? formatMoney(p.compare_at_price_min) : '';
          const priceHtml =
            comparePrice && parseFloat(comparePrice) > parseFloat(price)
              ? `<span class="search-drawer__product-price--sale">${price}</span> <s>${comparePrice}</s>`
              : price;
          return `<a href="${escapeHtml(p.url)}" class="search-drawer__product">
            <img class="search-drawer__product-image" src="${escapeHtml(
              img
            )}" alt="" width="56" height="56" loading="lazy">
            <div class="search-drawer__product-info">
              <p class="search-drawer__product-title">${escapeHtml(p.title)}</p>
              ${price ? `<p class="search-drawer__product-price">${priceHtml}</p>` : ''}
            </div>
          </a>`;
        })
        .join('');
    }

    function runSearch(query) {
      if (abortController) abortController.abort();
      abortController = new AbortController();

      setState('loading');
      const params = new URLSearchParams({
        q: query,
        'resources[type]': 'query,product',
        'resources[limit]': '10',
        'resources[limit_scope]': 'each',
        'resources[options][unavailable_products]': 'hide',
      });
      fetch(`${suggestUrl}?${params}`, { signal: abortController.signal })
        .then((res) => res.json())
        .then((data) => {
          const results = (data.resources && data.resources.results) || {};
          const queries = results.queries || [];
          const products = results.products || [];
          const hasAny = queries.length > 0 || products.length > 0;
          if (hasAny) {
            setState('results');
            renderOptions(queries);
            renderProducts(products);
          } else {
            setState('empty');
            if (optionsContainer) optionsContainer.innerHTML = '';
            if (productsContainer) productsContainer.innerHTML = '';
          }
        })
        .catch((err) => {
          if (err.name === 'AbortError') return;
          setState('empty');
        });
    }

    function onInput() {
      const query = (searchInput.value || '').trim();
      clearTimeout(debounceTimer);

      if (query.length < minChars) {
        setState('idle');
        if (optionsContainer) optionsContainer.innerHTML = '';
        if (productsContainer) productsContainer.innerHTML = '';
        return;
      }

      debounceTimer = setTimeout(() => runSearch(query), debounceMs);
    }

    searchInput.addEventListener('input', onInput);
    searchInput.addEventListener('focus', onInput);

    searchDrawer.addEventListener('drawer:open', () => {
      const query = (searchInput.value || '').trim();
      if (query.length >= minChars) runSearch(query);
      else setState('idle');
    });

    searchDrawer.addEventListener('drawer:close', () => {
      if (abortController) abortController.abort();
      clearTimeout(debounceTimer);
    });
  })();

  /**
   * Mobile menu search: same predictive search (options + top results) while typing
   */
  (function () {
    const mobileMenu = document.getElementById('mobile-menu');
    const mobileSearchInput = document.getElementById('mobile-search-input');
    const mobileResultsRegion = document.getElementById('mobile-search-results');

    if (!mobileMenu || !mobileSearchInput || !mobileResultsRegion) return;

    const stateIdle = mobileResultsRegion.querySelector('[data-mobile-search-state="idle"]');
    const stateLoading = mobileResultsRegion.querySelector('[data-mobile-search-state="loading"]');
    const stateResults = mobileResultsRegion.querySelector('[data-mobile-search-state="results"]');
    const stateEmpty = mobileResultsRegion.querySelector('[data-mobile-search-state="empty"]');
    const optionsContainer = mobileResultsRegion.querySelector('[data-mobile-search-options]');
    const productsContainer = mobileResultsRegion.querySelector('[data-mobile-search-products]');

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const suggestUrl = root.replace(/\/$/, '') + '/search/suggest.json';
    const minChars = 2;
    const debounceMs = 260;
    let debounceTimer = null;
    let abortController = null;

    function setState(state) {
      [stateIdle, stateLoading, stateResults, stateEmpty].forEach((el) => {
        if (el) el.hidden = true;
      });
      if (state === 'idle' && stateIdle) stateIdle.hidden = false;
      if (state === 'loading' && stateLoading) stateLoading.hidden = false;
      if (state === 'results' && stateResults) stateResults.hidden = false;
      if (state === 'empty' && stateEmpty) stateEmpty.hidden = false;
    }

    function escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    function renderOptions(queries) {
      if (!optionsContainer) return;
      const wrap = optionsContainer.closest('.mobile-menu__search-options-wrap');
      if (!queries || queries.length === 0) {
        optionsContainer.innerHTML = '';
        if (wrap) wrap.style.display = 'none';
        return;
      }
      if (wrap) wrap.style.display = 'block';
      optionsContainer.innerHTML = queries
        .slice(0, 5)
        .map(
          (q) =>
            `<a href="${escapeHtml(q.url)}" class="mobile-menu__search-option">${
              q.styled_text || escapeHtml(q.text)
            }</a>`
        )
        .join('');
    }

    function renderProducts(products) {
      if (!productsContainer) return;
      const wrap = productsContainer.closest('.mobile-menu__search-products-wrap');
      if (!products || products.length === 0) {
        productsContainer.innerHTML = '';
        if (wrap) wrap.style.display = 'none';
        return;
      }
      if (wrap) wrap.style.display = 'block';
      const formatMoney = (value) => {
        if (typeof window.themeFormatMoney === 'function') {
          return window.themeFormatMoney(value);
        }
        if (typeof window.Shopify !== 'undefined' && window.Shopify.formatMoney) {
          return window.Shopify.formatMoney(value);
        }
        const num = parseFloat(value);
        if (Number.isInteger(num) && num >= 100) return (num / 100).toFixed(2);
        return num.toFixed(2);
      };
      productsContainer.innerHTML = products
        .slice(0, 6)
        .map((p) => {
          const img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image || '';
          const price = p.price != null ? formatMoney(p.price) : '';
          const comparePrice =
            p.compare_at_price_min && p.compare_at_price_min > 0 ? formatMoney(p.compare_at_price_min) : '';
          const priceHtml =
            comparePrice && parseFloat(comparePrice) > parseFloat(price)
              ? `<span class="mobile-menu__search-product-price--sale">${price}</span> <s>${comparePrice}</s>`
              : price;
          return `<a href="${escapeHtml(p.url)}" class="mobile-menu__search-product">
            <img class="mobile-menu__search-product-image" src="${escapeHtml(
              img
            )}" alt="" width="48" height="48" loading="lazy">
            <div class="mobile-menu__search-product-info">
              <p class="mobile-menu__search-product-title">${escapeHtml(p.title)}</p>
              ${price ? `<p class="mobile-menu__search-product-price">${priceHtml}</p>` : ''}
            </div>
          </a>`;
        })
        .join('');
    }

    function runSearch(query) {
      if (abortController) abortController.abort();
      abortController = new AbortController();

      setState('loading');
      const params = new URLSearchParams({
        q: query,
        'resources[type]': 'query,product',
        'resources[limit]': '10',
        'resources[limit_scope]': 'each',
        'resources[options][unavailable_products]': 'hide',
      });
      fetch(`${suggestUrl}?${params}`, { signal: abortController.signal })
        .then((res) => res.json())
        .then((data) => {
          const results = (data.resources && data.resources.results) || {};
          const queries = results.queries || [];
          const products = results.products || [];
          const hasAny = queries.length > 0 || products.length > 0;
          if (hasAny) {
            setState('results');
            renderOptions(queries);
            renderProducts(products);
          } else {
            setState('empty');
            if (optionsContainer) optionsContainer.innerHTML = '';
            if (productsContainer) productsContainer.innerHTML = '';
          }
        })
        .catch((err) => {
          if (err.name === 'AbortError') return;
          setState('empty');
        });
    }

    function onInput() {
      const query = (mobileSearchInput.value || '').trim();
      clearTimeout(debounceTimer);

      if (query.length < minChars) {
        setState('idle');
        if (optionsContainer) optionsContainer.innerHTML = '';
        if (productsContainer) productsContainer.innerHTML = '';
        return;
      }

      debounceTimer = setTimeout(() => runSearch(query), debounceMs);
    }

    mobileSearchInput.addEventListener('input', onInput);
    mobileSearchInput.addEventListener('focus', onInput);

    mobileMenu.addEventListener('drawer:open', () => {
      const query = (mobileSearchInput.value || '').trim();
      if (query.length >= minChars) runSearch(query);
      else setState('idle');
    });

    mobileMenu.addEventListener('drawer:close', () => {
      if (abortController) abortController.abort();
      clearTimeout(debounceTimer);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  // Sort dropdown handler
  const sortTrigger = document.querySelector('[data-sort-trigger]');
  const sortPanel = document.querySelector('[data-sort-panel]');

  if (sortTrigger)
    sortTrigger.addEventListener('click', function (e) {
      e.stopPropagation();
      const isExpanded = this.getAttribute('aria-expanded') === 'true';

      // Close all filter dropdowns
      document.querySelectorAll('[data-filter-trigger]').forEach((t) => {
        t.setAttribute('aria-expanded', 'false');
      });

      this.setAttribute('aria-expanded', !isExpanded);
    });

  // Sort option click handler
  document.querySelectorAll('[data-sort-value]').forEach((option) => {
    option.addEventListener('click', function () {
      const value = this.getAttribute('data-sort-value');
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      window.location.href = url.toString();
    });
  });

  // Filter dropdown handlers
  document.querySelectorAll('[data-filter-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      const isExpanded = this.getAttribute('aria-expanded') === 'true';

      // Close sort dropdown
      if (sortTrigger) sortTrigger.setAttribute('aria-expanded', 'false');

      // Close all other filter dropdowns
      document.querySelectorAll('[data-filter-trigger]').forEach((t) => {
        t.setAttribute('aria-expanded', 'false');
      });

      // Toggle current dropdown
      this.setAttribute('aria-expanded', !isExpanded);
    });
  });

  // Close all dropdowns when clicking outside
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-filter-dropdown]') && !e.target.closest('[data-sort-dropdown]')) {
      document.querySelectorAll('[data-filter-trigger]').forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
      });
      if (sortTrigger) sortTrigger.setAttribute('aria-expanded', 'false');
    }
  });

  // Close all dropdowns on escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-filter-trigger]').forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
      });
      if (sortTrigger) sortTrigger.setAttribute('aria-expanded', 'false');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Product Gallery - Carousel showing 2 images at a time, moving 1 at a time
  class ProductGallery {
    constructor(container) {
      this.container = container;
      this.track = container.querySelector('[data-gallery-track]');
      this.items = container.querySelectorAll('.product-gallery__item');
      this.thumbs = container.querySelectorAll('.product-gallery__thumb');
      this.prevBtn = container.querySelector('[data-gallery-prev]');
      this.nextBtn = container.querySelector('[data-gallery-next]');
      this.totalItems = this.items.length;
      this.currentIndex = 0;
      this.desktopLayout = container.dataset.desktopLayout || 'carousel';

      this.calculateVisibleCount();
      this.bindEvents();
      this.updateNavState();
      this.updateThumbnails();
    }

    isGridMode() {
      return this.desktopLayout === 'grid' && window.innerWidth >= 1200;
    }

    calculateVisibleCount() {
      if (this.isGridMode()) {
        this.visibleCount = this.totalItems;
        this.maxIndex = 0;
        return;
      }
      this.visibleCount = window.innerWidth >= 1200 ? 2 : 1;
      this.maxIndex = Math.max(0, this.totalItems - this.visibleCount);
    }

    bindEvents() {
      this.thumbs.forEach((thumb) => {
        const index = parseInt(thumb.dataset.thumbIndex, 10);
        thumb.addEventListener('click', () => this.goTo(index));
      });

      this.prevBtn?.addEventListener('click', () => this.prev());
      this.nextBtn?.addEventListener('click', () => this.next());

      // Swipe support
      let startX = 0;
      this.container.addEventListener(
        'touchstart',
        (e) => {
          startX = e.touches[0].clientX;
        },
        { passive: true }
      );

      this.container.addEventListener(
        'touchend',
        (e) => {
          const diffX = startX - e.changedTouches[0].clientX;
          if (Math.abs(diffX) > 50) {
            if (diffX > 0) this.next();
            else this.prev();
          }
        },
        { passive: true }
      );

      window.addEventListener('resize', () => {
        const prevGridMode = this._wasGridMode;
        this._wasGridMode = this.isGridMode();

        this.calculateVisibleCount();

        if (this.currentIndex > this.maxIndex) {
          this.currentIndex = this.maxIndex;
        }
        this.updateCarousel();
        this.updateNavState();
      });
    }

    goTo(index) {
      if (this.isGridMode()) return;
      this.currentIndex = Math.max(0, Math.min(index, this.maxIndex));
      this.updateCarousel();
    }

    updateCarousel() {
      if (this.isGridMode()) {
        this.track.style.transform = 'none';
        return;
      }
      const itemWidth = 100 / this.visibleCount;
      const offsetPercent = this.currentIndex * itemWidth;
      this.track.style.transform = `translateX(-${offsetPercent}%)`;

      this.updateThumbnails();
      this.updateNavState();
    }

    updateThumbnails() {
      // Highlight thumbs for currently visible images
      const endIndex = this.currentIndex + this.visibleCount;

      this.thumbs.forEach((thumb, index) => {
        const isActive = index >= this.currentIndex && index < endIndex;
        thumb.classList.toggle('is-active', isActive);

        // Scroll active thumbnail into view
        if (isActive && index === this.currentIndex) {
          this.scrollThumbIntoView(thumb);
        }
      });
    }

    scrollThumbIntoView(thumb) {
      const thumbnailsContainer = this.container.querySelector('[data-gallery-thumbnails]');
      const thumbnailsTrack = thumbnailsContainer?.querySelector('.product-gallery__thumbnails-track');

      if (!thumbnailsTrack) return;

      const containerRect = thumbnailsTrack.getBoundingClientRect();
      const thumbRect = thumb.getBoundingClientRect();
      const isHorizontal = this.container.classList.contains('product-gallery--horizontal');

      if (isHorizontal) {
        // Horizontal scrolling
        if (thumbRect.left < containerRect.left) {
          thumbnailsTrack.scrollTo({
            left: thumbnailsTrack.scrollLeft + (thumbRect.left - containerRect.left) - 8,
            behavior: 'smooth',
          });
        } else if (thumbRect.right > containerRect.right) {
          thumbnailsTrack.scrollTo({
            left: thumbnailsTrack.scrollLeft + (thumbRect.right - containerRect.right) + 8,
            behavior: 'smooth',
          });
        }
      } else {
        // Vertical scrolling
        if (thumbRect.top < containerRect.top) {
          thumbnailsTrack.scrollTo({
            top: thumbnailsTrack.scrollTop + (thumbRect.top - containerRect.top) - 8,
            behavior: 'smooth',
          });
        } else if (thumbRect.bottom > containerRect.bottom) {
          thumbnailsTrack.scrollTo({
            top: thumbnailsTrack.scrollTop + (thumbRect.bottom - containerRect.bottom) + 8,
            behavior: 'smooth',
          });
        }
      }
    }

    updateNavState() {
      const gridActive = this.isGridMode();
      if (this.prevBtn) {
        this.prevBtn.disabled = gridActive || this.currentIndex === 0;
      }
      if (this.nextBtn) {
        this.nextBtn.disabled = gridActive || this.currentIndex >= this.maxIndex;
      }
    }

    prev() {
      if (this.currentIndex > 0) {
        this.goTo(this.currentIndex - 1);
      }
    }

    next() {
      if (this.currentIndex < this.maxIndex) {
        this.goTo(this.currentIndex + 1);
      }
    }
  }

  // Luxury Accordions - Smooth animated accordions
  class LuxuryAccordions extends HTMLElement {
    constructor() {
      super();
      this.accordions = [];
      this.exclusive = this.dataset.exclusive === 'true';
    }

    connectedCallback() {
      this.accordions = this.querySelectorAll('[data-accordion]');

      this.accordions.forEach((accordion) => {
        const trigger = accordion.querySelector('[data-accordion-trigger]');
        const content = accordion.querySelector('[data-accordion-content]');

        if (trigger && content) {
          trigger.addEventListener('click', () => this.toggle(accordion));

          if (accordion.classList.contains('is-open')) {
            if (this.isCarouselContent(content)) {
              content.style.height = 'auto';
              content.style.overflow = 'visible';
            } else {
              content.style.height = content.scrollHeight + 'px';
            }
          }
        }
      });
    }

    isCarouselContent(content) {
      return content.classList.contains('luxury-accordion__content--carousel');
    }

    toggle(accordion) {
      const isOpen = accordion.classList.contains('is-open');

      if (this.exclusive && !isOpen) {
        // Close all other accordions first
        this.accordions.forEach((acc) => {
          if (acc !== accordion && acc.classList.contains('is-open')) {
            this.close(acc);
          }
        });
      }

      if (isOpen) {
        this.close(accordion);
      } else {
        this.open(accordion);
      }
    }

    open(accordion) {
      const content = accordion.querySelector('[data-accordion-content]');
      const trigger = accordion.querySelector('[data-accordion-trigger]');

      if (this.isCarouselContent(content)) {
        content.style.height = 'auto';
        content.style.overflow = 'visible';
        accordion.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        return;
      }

      // Get the natural height
      content.style.height = content.scrollHeight + 'px';

      accordion.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');

      // After animation, set height to auto for dynamic content
      content.addEventListener('transitionend', function handler() {
        if (accordion.classList.contains('is-open')) {
          content.style.height = 'auto';
        }
        content.removeEventListener('transitionend', handler);
      });
    }

    close(accordion) {
      const content = accordion.querySelector('[data-accordion-content]');
      const trigger = accordion.querySelector('[data-accordion-trigger]');

      if (this.isCarouselContent(content)) {
        content.style.overflow = 'hidden';
        content.style.height = content.scrollHeight + 'px';
        content.offsetHeight;
        content.style.height = '0';
        accordion.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        return;
      }

      // Set explicit height before animating to 0
      content.style.height = content.scrollHeight + 'px';

      // Force reflow
      content.offsetHeight;

      // Animate to 0
      content.style.height = '0';

      accordion.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }
  }

  customElements.define('luxury-accordions', LuxuryAccordions);

  class ShopPrintCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';

      this.track = this.querySelector('[data-shop-print-track]');
      this.prevBtn = this.querySelector('[data-shop-print-prev]');
      this.nextBtn = this.querySelector('[data-shop-print-next]');

      if (!this.track) return;

      let isDragging = false;
      let startX = 0;
      let scrollStart = 0;
      let moved = false;

      this.track.addEventListener('mousedown', (event) => {
        isDragging = true;
        moved = false;
        startX = event.pageX;
        scrollStart = this.track.scrollLeft;
      });

      this.track.addEventListener('mousemove', (event) => {
        if (!isDragging) return;
        event.preventDefault();
        const delta = event.pageX - startX;
        if (Math.abs(delta) > 3) moved = true;
        this.track.scrollLeft = scrollStart - delta;
      });

      const endDrag = () => {
        isDragging = false;
      };

      this.track.addEventListener('mouseup', endDrag);
      this.track.addEventListener('mouseleave', endDrag);

      this.track.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', (event) => {
          if (moved) event.preventDefault();
        });
      });

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.scrollByDirection(-1));
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.scrollByDirection(1));
      }

      this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
      window.addEventListener('resize', () => this.updateButtons());

      this.updateButtons();
    }

    getScrollStep() {
      const card = this.track.querySelector('.shop-print__card');
      if (!card) return 0;
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      return card.offsetWidth + gap;
    }

    scrollByDirection(direction) {
      const step = this.getScrollStep();
      if (!step) return;
      this.track.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    updateButtons() {
      if (!this.track || !this.prevBtn || !this.nextBtn) return;

      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const hasOverflow = scrollWidth > clientWidth + 1;

      this.prevBtn.hidden = !hasOverflow;
      this.nextBtn.hidden = !hasOverflow;

      if (!hasOverflow) return;

      this.prevBtn.disabled = scrollLeft <= 1;
      this.nextBtn.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
    }
  }

  customElements.define('shop-print-carousel', ShopPrintCarousel);

  // Product Tabs
  class ProductTabs extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.tabs = this.querySelectorAll('.product-tabs__tab');
      this.panels = this.querySelectorAll('.product-tabs__panel');

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.switchTab(tab.dataset.tab));
      });
    }

    switchTab(tabId) {
      this.tabs.forEach((tab) => {
        tab.classList.toggle('is-active', tab.dataset.tab === tabId);
        tab.setAttribute('aria-selected', tab.dataset.tab === tabId);
      });

      this.panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.panel === tabId);
      });
    }
  }

  customElements.define('product-tabs', ProductTabs);

  // Variant Picker
  class ProductVariantPicker {
    constructor(container) {
      this.container = container;
      this.form = container.querySelector('[data-product-form]');
      this.variantIdInput = this.form?.querySelector('input[name="id"]');
      this.optionInputs = container.querySelectorAll('[data-option-input]');
      this.priceEl = container.querySelector('[data-product-price]');
      this.afterpayEl = container.querySelector('[data-afterpay-price]');
      this.lowStockEl = container.querySelector('[data-low-stock]');
      this.addBtn = container.querySelector('.product-form__add-btn');
      this.cartRoutes = this.getCartRoutes();
      this.productData = this.getProductData();
      this.variantInventory = this.getVariantInventoryMap();
      this.bindEvents();
    }

    getCartRoutes() {
      const el = this.container.querySelector('[data-cart-routes]');
      if (!el) return null;
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        return null;
      }
    }

    getCartAddUrl() {
      if (this.cartRoutes?.add) return this.cartRoutes.add;
      const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '');
      return `${root}/cart/add.js`;
    }

    getCartUrl() {
      if (this.cartRoutes?.cart) return this.cartRoutes.cart;
      const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '');
      return `${root}/cart.js`;
    }

    parseResponseJson(text) {
      try {
        return JSON.parse(text);
      } catch (e) {
        return null;
      }
    }

    getProductData() {
      const productJson = this.container.querySelector('[data-product-json]');
      if (!productJson) return null;
      try {
        return JSON.parse(productJson.textContent);
      } catch (e) {
        console.error('Could not parse product JSON', e);
        return null;
      }
    }

    getVariantInventoryMap() {
      const el = this.container.querySelector('[data-variant-inventory]');
      if (!el) return null;
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        return null;
      }
    }

    bindEvents() {
      if (this.optionInputs.length > 0) {
        this.container.addEventListener('change', (e) => {
          if (e.target.matches('[data-option-input]')) {
            this.onOptionChange(e);
          }
        });

        this.updateSwatchSelection();
        this.initSizeConversion();
        this.syncVariantFromSelectedOptions();
        this.syncLowStockFromCurrentVariant();
      }

      this.form?.addEventListener('submit', (e) => this.onFormSubmit(e));
    }

    syncVariantFromSelectedOptions() {
      const variant = this.findVariant(this.getSelectedOptions());
      if (variant) this.updateVariant(variant);
    }

    getCurrentVariant() {
      const variantId = this.variantIdInput?.value;
      if (!variantId || !this.productData?.variants) return null;
      return this.productData.variants.find((v) => String(v.id) === String(variantId)) ?? null;
    }

    syncLowStockFromCurrentVariant() {
      const variant = this.getCurrentVariant();
      if (variant) this.updateLowStock(variant);
    }

    initSizeConversion() {
      const el = this.container.querySelector('[data-size-conversion-config]');
      if (!el) return;

      let config;
      try {
        config = JSON.parse(el.textContent);
      } catch (e) {
        return;
      }

      if (!config.rows || !config.rows.length) return;

      const tabs = this.container.querySelectorAll('[data-size-region-tab]');
      if (!tabs.length) return;

      const storageKey = 'product-size-region';
      const storageCol = Number(config.storageColumn) || 0;

      const labelFor = (canonical, regionIndex) => {
        const row = config.rows.find((r) => {
          const cell = r[storageCol];
          return String(cell != null ? cell : '').trim() === String(canonical).trim();
        });
        if (!row || row[regionIndex] == null || String(row[regionIndex]).trim() === '') {
          return canonical;
        }
        return String(row[regionIndex]).trim();
      };

      const apply = (regionIndex) => {
        this.container.querySelectorAll('[data-size-label]').forEach((label) => {
          const canonical = label.dataset.canonical;
          if (canonical == null) return;
          label.textContent = labelFor(canonical, regionIndex);
        });
      };

      const setActiveTab = (regionIndex) => {
        tabs.forEach((tab) => {
          const idx = parseInt(tab.dataset.sizeRegionIndex, 10);
          const on = idx === regionIndex;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      };

      let regionIndex = 0;
      const activeEl = this.container.querySelector('[data-size-region-tab].is-active');
      if (activeEl) {
        regionIndex = parseInt(activeEl.dataset.sizeRegionIndex, 10);
      }
      if (Number.isNaN(regionIndex)) regionIndex = 0;

      if (config.persist) {
        try {
          const saved = localStorage.getItem(storageKey);
          if (saved !== null) {
            const n = parseInt(saved, 10);
            const max = (config.headers && config.headers.length) || 8;
            if (!Number.isNaN(n) && n >= 0 && n < max) {
              regionIndex = n;
              setActiveTab(regionIndex);
            }
          }
        } catch (e) {
          // localStorage may be unavailable
        }
      }

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const idx = parseInt(tab.dataset.sizeRegionIndex, 10);
          if (Number.isNaN(idx)) return;
          regionIndex = idx;
          setActiveTab(regionIndex);
          apply(regionIndex);
          if (config.persist) {
            try {
              localStorage.setItem(storageKey, String(idx));
            } catch (e) {
              // ignore
            }
          }
        });
      });

      apply(regionIndex);
    }

    getSelectedVariant() {
      if (this.optionInputs.length > 0) {
        const fromOptions = this.findVariant(this.getSelectedOptions());
        if (fromOptions) return fromOptions;
      }
      return this.getCurrentVariant();
    }

    async onFormSubmit(e) {
      e.preventDefault();

      if (!this.form || this.addBtn?.disabled) return;

      const variant = this.getSelectedVariant();
      const variantId = parseInt(variant?.id, 10);

      if (!variantId) {
        alert('Please select an available option.');
        return;
      }

      if (this.variantIdInput) {
        this.variantIdInput.value = String(variantId);
      }

      this.setLoading(true);

      const cartAddUrl = this.getCartAddUrl();

      try {
        const formData = new FormData(this.form);
        formData.set('id', String(variantId));
        formData.set('quantity', formData.get('quantity') || '1');

        const response = await fetch(cartAddUrl, {
          method: 'POST',
          body: formData,
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        });

        const text = await response.text();
        const data = this.parseResponseJson(text);

        if (!data) {
          console.error('Add to cart non-JSON response', response.status, cartAddUrl, text.slice(0, 300));
          throw new Error('Could not add to cart. Please try again.');
        }

        if (!response.ok) {
          throw new Error(data.description || data.message || 'Could not add to cart');
        }

        document.dispatchEvent(new CustomEvent('cart:add', { detail: { item: data } }));
        document.dispatchEvent(new CustomEvent('cart:open'));

        this.updateCartCount();
      } catch (error) {
        console.error('Add to cart error:', error);
        alert(error.message || 'Could not add to cart. Please try again.');
      } finally {
        this.setLoading(false);
      }
    }

    setLoading(loading) {
      if (this.addBtn) {
        this.addBtn.classList.toggle('is-loading', loading);
        this.addBtn.disabled = loading;
      }
    }

    async updateCartCount() {
      try {
        const response = await fetch(this.getCartUrl(), {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });
        const cart = this.parseResponseJson(await response.text());
        if (!cart?.item_count && cart?.item_count !== 0) return;
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      } catch (error) {
        console.error('Error updating cart count:', error);
      }
    }

    onOptionChange(e) {
      const variant = this.findVariant(this.getSelectedOptions());

      this.updateSwatchSelection();

      if (variant) {
        this.updateVariant(variant);
        this.updateUrl(variant);
      } else {
        this.updateLowStock(null);
      }
    }

    getSelectedOptions() {
      const options = [];
      this.container.querySelectorAll('[data-option-input]:checked').forEach((radio) => {
        const position = parseInt(radio.dataset.optionPosition, 10);
        if (!Number.isNaN(position)) {
          options[position - 1] = radio.value;
        }
      });
      return options;
    }

    resolveSelectedOptions(partialOptions) {
      const current = this.getCurrentVariant();
      const optionCount = this.productData?.options?.length ?? 3;

      return Array.from({ length: optionCount }, (_, i) => {
        const sel = partialOptions[i];
        if (sel !== undefined && sel !== null && sel !== '') return sel;
        return current?.[`option${i + 1}`] ?? null;
      });
    }

    getVariantOptions(variant) {
      if (Array.isArray(variant.options) && variant.options.length) {
        return variant.options;
      }
      return [variant.option1, variant.option2, variant.option3];
    }

    findVariant(partialOptions) {
      if (!this.productData?.variants) return null;

      const resolved = this.resolveSelectedOptions(partialOptions);
      const norm = (v) => String(v ?? '').trim();

      return (
        this.productData.variants.find((variant) => {
          const variantOpts = this.getVariantOptions(variant);
          return resolved.every((opt, i) => {
            if (opt === null || opt === '') return true;
            const variantValue = variantOpts[i] ?? variant[`option${i + 1}`];
            return norm(variantValue) === norm(opt);
          });
        }) ?? null
      );
    }

    updateVariant(variant) {
      if (this.variantIdInput) {
        this.variantIdInput.value = variant.id;
      }

      // Update price
      const fmt =
        typeof window.themeFormatMoney === 'function' ? window.themeFormatMoney : (c) => Shopify.formatMoney(c);
      if (this.priceEl) {
        this.priceEl.textContent = fmt(variant.price);
      }

      if (this.afterpayEl) {
        this.afterpayEl.textContent = fmt(Math.floor(variant.price / 4));
      }

      // Update add button
      if (this.addBtn) {
        this.addBtn.disabled = !variant.available;
        this.addBtn.querySelector('span').textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
      }

      this.updateLowStock(variant);
    }

    updateLowStock(variant) {
      const el = this.lowStockEl;
      if (!el) return;

      const threshold = parseInt(el.dataset.threshold, 10) || 5;
      const scope = el.dataset.scope || 'variant';
      const showCount = el.dataset.showCount === 'true';
      const message = el.dataset.message || 'Limited availability';
      const messageCount = el.dataset.messageCount || 'Only [count] remaining';
      const textEl = el.querySelector('[data-low-stock-text]');
      const inventory = this.variantInventory;
      const getInv = (id) => (inventory ? inventory[String(id)] : null);

      let show = false;
      let count = 0;

      const inv = variant ? getInv(variant.id) : null;
      const isAvailable = inv?.available ?? variant?.available;

      if (variant && isAvailable) {
        if (scope === 'variant') {
          if (inv?.tracked && inv.deny_oversell) {
            count = inv.quantity ?? 0;
            show = count > 0 && count <= threshold;
          } else if (variant.inventory_management && variant.inventory_policy === 'deny') {
            count = variant.inventory_quantity ?? 0;
            show = count > 0 && count <= threshold;
          }
        } else if (inventory) {
          count = Object.values(inventory).reduce((sum, inv) => {
            if (inv.tracked && inv.deny_oversell) {
              return sum + (inv.quantity || 0);
            }
            return sum;
          }, 0);
          show = count > 0 && count <= threshold;
        }
      }

      if (show) {
        const text = showCount ? messageCount.replace('[count]', String(count)) : message;
        if (textEl) textEl.textContent = text;
        el.hidden = false;
        el.classList.remove('is-hidden');
      } else {
        el.hidden = true;
        el.classList.add('is-hidden');
      }
    }

    updateUrl(variant) {
      try {
        const urlObj = new URL(window.location);
        urlObj.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', urlObj.toString());
      } catch (error) {
        console.warn('Could not update URL:', error);
      }
    }

    updateSwatchSelection() {
      // Update color value display - find the color option by checking option names
      const colorValueEl = this.container.querySelector('[data-option-value]');
      if (colorValueEl && this.optionInputs.length > 0) {
        // Find the checked input for a color option (not size, fit, etc.)
        let colorInput = null;
        this.optionInputs.forEach((input) => {
          if (input.checked) {
            const optionPosition = input.dataset.optionPosition;
            // Get the option group to check its name
            const optionLabel = this.container.querySelector(
              `[data-option-input][data-option-position="${optionPosition}"]`
            );
            if (optionLabel) {
              // Find the parent product-option div to get the label
              const optionContainer = optionLabel.closest('.product-option');
              if (optionContainer) {
                const optionName =
                  optionContainer.querySelector('.product-option__label')?.textContent.toLowerCase() || '';
                // Check if this is a color option
                if (optionName.includes('color') || optionName.includes('colour')) {
                  colorInput = input;
                }
              }
            }
          }
        });

        // Only update if we found a color input
        if (colorInput) {
          colorValueEl.textContent = colorInput.value;
        }
      }

      // Update swatch and size visual states
      const labels = this.container.querySelectorAll('.product-swatch, .product-size');

      labels.forEach((label) => {
        const input = label.querySelector('input');
        if (input) {
          if (input.checked) {
            label.classList.add('is-selected');
          } else {
            label.classList.remove('is-selected');
          }
        }
      });
    }
  }

  // Initialize
  document.addEventListener('DOMContentLoaded', () => {
    // Calculate scrollbar width and set CSS variable
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');

    const gallery = document.querySelector('[data-gallery]');
    if (gallery) new ProductGallery(gallery);

    const productMain = document.querySelector('.product-main');
    if (productMain) new ProductVariantPicker(productMain);

    // Size Chart Drawer - initialize with event delegation
    setTimeout(() => {
      initSizeChart();
    }, 100);
  });

  function initSizeChart() {
    const drawer = document.getElementById('size-chart-drawer');
    if (!drawer) return;

    const productDataEl = document.getElementById('product-data');
    let productData = {};
    if (productDataEl) {
      try {
        productData = JSON.parse(productDataEl.textContent || '{}');
      } catch (err) {
        // JSON parse error
      }
    }

    const availableCharts = productData.size_charts || [];
    const selectedChartName = productData.size_chart_selection || '';
    let selectedChart = availableCharts.find((c) => c.name === selectedChartName);
    if (!selectedChart && availableCharts.length > 0) {
      selectedChart = availableCharts[0];
    }

    document.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-size-guide-trigger]');
      if (btn && selectedChart) {
        e.preventDefault();
        renderSizeChart(selectedChart);
        drawer.showModal();
        document.body.classList.add('scroll-lock');
      }
    });

    const closeBtn = drawer.querySelector('[data-size-chart-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => closeDrawer(drawer));
    }

    drawer.addEventListener('click', (e) => {
      if (e.target === drawer) {
        closeDrawer(drawer);
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.open) {
        e.preventDefault();
        closeDrawer(drawer);
      }
    });
  }

  function closeDrawer(drawer) {
    drawer.classList.add('is-closing');
    setTimeout(() => {
      drawer.close();
      drawer.classList.remove('is-closing');
      document.body.classList.remove('scroll-lock');
    }, 300);
  }

  function isSizeChartUnusedValue(v) {
    const s = String(v ?? '').trim();
    return s === '' || s === '\u2014';
  }

  function isSizeChartExcludedColumn(header) {
    const s = String(header ?? '').trim();
    if (isSizeChartUnusedValue(s)) return false;
    return (
      /^tc\s*size$/i.test(s) ||
      /^bust\s*\(cm\)$/i.test(s) ||
      /^waist\s*\(cm\)$/i.test(s) ||
      /^hip\s*\(cm\)$/i.test(s)
    );
  }

  function filterExcludedColumns(chart) {
    const columns = chart.columns || [];
    const rows = chart.rows || [];
    const keepIndices = [];
    for (let i = 0; i < columns.length; i++) {
      if (!isSizeChartExcludedColumn(columns[i])) keepIndices.push(i);
    }
    return {
      columns: keepIndices.map((i) => columns[i]),
      rows: rows.map((row) => keepIndices.map((i) => (row && row[i]) ?? '')),
    };
  }

  function trimTrailingEmptyColumns(chart) {
    const columns = chart.columns || [];
    const rows = chart.rows || [];
    let last = columns.length - 1;
    while (last >= 0) {
      const headerUnused = isSizeChartUnusedValue(columns[last]);
      const colHasRealData = rows.some((row) => !isSizeChartUnusedValue(row && row[last]));
      if (!headerUnused || colHasRealData) break;
      last--;
    }
    const n = last + 1;
    if (n <= 0) return { columns: [], rows: rows.map(() => []) };
    return {
      columns: columns.slice(0, n),
      rows: rows.map((row) => {
        const r = row || [];
        const out = [];
        for (let i = 0; i < n; i++) out.push(r[i]);
        return out;
      }),
    };
  }

  function renderSizeChart(chart) {
    const table = document.getElementById('size-chart-table');
    if (!table) return;

    const trimmed = trimTrailingEmptyColumns(filterExcludedColumns(chart));
    const thead = table.querySelector('thead');
    const tbody = table.querySelector('tbody');
    thead.innerHTML = '';
    tbody.innerHTML = '';

    const columns = trimmed.columns || [];
    const colCount = columns.length;

    const headerRow = document.createElement('tr');
    columns.forEach((col) => {
      const th = document.createElement('th');
      const raw = col != null ? String(col) : '';
      th.textContent = isSizeChartUnusedValue(raw) ? '' : raw;
      headerRow.appendChild(th);
    });
    thead.appendChild(headerRow);

    (trimmed.rows || []).forEach((row) => {
      const tr = document.createElement('tr');
      for (let i = 0; i < colCount; i++) {
        const td = document.createElement('td');
        const cell = row && row[i];
        const raw = cell != null ? String(cell) : '';
        td.textContent = isSizeChartUnusedValue(raw) ? '' : raw;
        tr.appendChild(td);
      }
      tbody.appendChild(tr);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  class Slideshow {
    constructor(container) {
      this.container = container;
      this.track = this.container.querySelector('.slideshow__track');
      this.slides = this.container.querySelectorAll('.slideshow__slide');
      this.dots = this.container.querySelectorAll('.slideshow__dot');
      this.prevBtn = this.container.querySelector('[data-slideshow-prev]');
      this.nextBtn = this.container.querySelector('[data-slideshow-next]');
      this.currentIndex = 0;
      this.visualIndex = 0;
      this.autoAdvance = this.container.dataset.autoAdvance === 'true';
      this.advanceInterval = parseInt(this.container.dataset.advanceInterval || 5000);
      this.timer = null;
      this.isTransitioning = false;

      this.init();
    }

    init() {
      if (this.slides.length === 0) return;

      // Clone first and last slides for infinite loop
      if (this.slides.length > 1) {
        this.createClones();
      }

      // Set initial position (offset by 1 because of clone)
      this.visualIndex = this.slides.length > 1 ? 1 : 0;
      this.updateTrackPosition(false);

      // Setup navigation
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.prev());
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.next());
      }

      // Setup dots
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });

      // Setup keyboard navigation
      this.container.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.prev();
        if (e.key === 'ArrowRight') this.next();
      });

      // Setup auto-advance
      if (this.autoAdvance) {
        this.startAutoAdvance();

        // Pause on hover
        this.container.addEventListener('mouseenter', () => this.stopAutoAdvance());
        this.container.addEventListener('mouseleave', () => this.startAutoAdvance());

        // Pause on focus (accessibility)
        this.container.addEventListener('focusin', () => this.stopAutoAdvance());
        this.container.addEventListener('focusout', () => this.startAutoAdvance());
      }

      // Pause videos on inactive slides
      this.pauseInactiveVideos();
    }

    createClones() {
      const firstSlide = this.track.querySelector('.slideshow__slide-wrapper:first-child');
      const lastSlide = this.track.querySelector('.slideshow__slide-wrapper:last-child');

      if (firstSlide && lastSlide) {
        const firstClone = firstSlide.cloneNode(true);
        const lastClone = lastSlide.cloneNode(true);

        firstClone.classList.add('slideshow__slide-wrapper--clone');
        lastClone.classList.add('slideshow__slide-wrapper--clone');

        this.track.appendChild(firstClone);
        this.track.insertBefore(lastClone, firstSlide);
      }
    }

    goToSlide(index, transition = true) {
      if (this.isTransitioning) return;

      // Handle wrapping
      let targetIndex = index;
      if (index < 0) targetIndex = this.slides.length - 1;
      if (index >= this.slides.length) targetIndex = 0;

      if (targetIndex === this.currentIndex) return;

      this.isTransitioning = true;

      // Update dots
      if (this.dots[this.currentIndex]) {
        this.dots[this.currentIndex].classList.remove('is-active');
      }
      if (this.dots[targetIndex]) {
        this.dots[targetIndex].classList.add('is-active');
      }

      // Calculate visual index (offset by 1 for the prepended clone if we have multiple slides)
      this.currentIndex = targetIndex;
      this.visualIndex = this.slides.length > 1 ? this.currentIndex + 1 : this.currentIndex;
      this.updateTrackPosition(transition);

      // Get transition duration from CSS
      const duration = parseInt(
        getComputedStyle(this.track).getPropertyValue('--slideshow-transition-duration') || 500
      );

      // Reset transitioning state
      setTimeout(
        () => {
          this.isTransitioning = false;
          this.pauseInactiveVideos();
        },
        transition ? duration : 0
      );
    }

    updateTrackPosition(transition = true) {
      if (this.track) {
        if (!transition) {
          this.track.classList.add('slideshow__track--no-transition');
        }

        this.track.style.setProperty('--slideshow-current-index', this.visualIndex);

        if (!transition) {
          // Force reflow
          this.track.offsetHeight;
          this.track.classList.remove('slideshow__track--no-transition');
        }
      }
    }

    next() {
      // Prevent multiple transitions from stacking
      if (this.isTransitioning) return;
      
      if (this.slides.length > 1) {
        this.isTransitioning = true;
        this.visualIndex++;

        // Update current index for dots
        const newIndex = (this.currentIndex + 1) % this.slides.length;
        if (this.dots[this.currentIndex]) {
          this.dots[this.currentIndex].classList.remove('is-active');
        }
        if (this.dots[newIndex]) {
          this.dots[newIndex].classList.add('is-active');
        }
        this.currentIndex = newIndex;

        this.updateTrackPosition(true);

        const duration = parseInt(
          getComputedStyle(this.track).getPropertyValue('--slideshow-transition-duration') || 500
        );

        setTimeout(() => {
          // If we transitioned to the first clone, jump back to real first slide
          if (this.visualIndex === this.slides.length + 1) {
            this.visualIndex = 1;
            this.updateTrackPosition(false);
          }
          this.isTransitioning = false;
          this.pauseInactiveVideos();
        }, duration);
      }

      if (this.autoAdvance) {
        this.resetAutoAdvance();
      }
    }

    prev() {
      // Prevent multiple transitions from stacking
      if (this.isTransitioning) return;
      
      if (this.slides.length > 1) {
        this.isTransitioning = true;
        this.visualIndex--;

        // Update current index for dots
        let newIndex = this.currentIndex - 1;
        if (newIndex < 0) newIndex = this.slides.length - 1;

        if (this.dots[this.currentIndex]) {
          this.dots[this.currentIndex].classList.remove('is-active');
        }
        if (this.dots[newIndex]) {
          this.dots[newIndex].classList.add('is-active');
        }
        this.currentIndex = newIndex;

        this.updateTrackPosition(true);

        const duration = parseInt(
          getComputedStyle(this.track).getPropertyValue('--slideshow-transition-duration') || 500
        );

        setTimeout(() => {
          // If we transitioned to the last clone, jump to real last slide
          if (this.visualIndex === 0) {
            this.visualIndex = this.slides.length;
            this.updateTrackPosition(false);
          }
          this.isTransitioning = false;
          this.pauseInactiveVideos();
        }, duration);
      }

      if (this.autoAdvance) {
        this.resetAutoAdvance();
      }
    }

    startAutoAdvance() {
      if (!this.autoAdvance || this.slides.length <= 1) return;
      this.timer = setInterval(() => this.next(), this.advanceInterval);
    }

    stopAutoAdvance() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    resetAutoAdvance() {
      this.stopAutoAdvance();
      this.startAutoAdvance();
    }

    pauseInactiveVideos() {
      this.slides.forEach((slide, index) => {
        const videos = slide.querySelectorAll('video');
        videos.forEach((video) => {
          if (index === this.currentIndex) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      });
    }
  }

  // Initialize slideshows
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-slideshow]').forEach((container) => {
      new Slideshow(container);
    });
  });

  // Handle Shopify theme editor events
  if (Shopify?.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const container = event.target.querySelector('[data-slideshow]');
      if (container) new Slideshow(container);
    });

    document.addEventListener('shopify:section:reorder', () => {
      document.querySelectorAll('[data-slideshow]').forEach((container) => {
        new Slideshow(container);
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
